// Botão que só acende quando existe conta aberta.
import React from "react";
import { DadosDoPedido } from "../../../../store/Slices/orderSlice";
import * as Styles from "../../styles/PointOfSale.styles";

export const BotaoDePedido: React.FC<{
  component: any;
  componentProps: any;
  buttonLabel: any;
  buttonBrightness: any;
  orderDataZustand: DadosDoPedido;
  handleButtonClick: (acao: string, event?: React.MouseEvent) => void;
}> = ({
  component,
  componentProps,
  buttonLabel,
  buttonBrightness,
  orderDataZustand,
  handleButtonClick,
}) => {
  return (
    <Styles.Button
      selected={Boolean(component.componentSelected)}
      id={String(component.componentId)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={
        orderDataZustand.orderUuid === ""
          ? "0.2"
          : String(buttonBrightness)
      }
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentStatus={String(componentProps.componentStatus)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
      componentColor={String(componentProps.componentColor)}
      onClick={(event) => {
        handleButtonClick(
          componentProps.componentAction as string,
          event as any
        );
      }}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      {componentProps.componentShortcut !== "" ? (
        <>
          <span className="buttonLabel">{buttonLabel}</span>
          <Styles.Divider orientation={"vertical"} />
          <span className="shortcut">
            {componentProps.componentShortcut}
          </span>
        </>
      ) : (
        <>
          <span className="buttonLabel">{buttonLabel}</span>
        </>
      )}
    </Styles.Button>
  );
};
